import { Box, Dialog, DialogContent, Fab } from '@mui/material'
import { MouseEvent, useState, useEffect } from 'react'
import GridLayoutSelection from './GridLayoutSelection'
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined'
import { useAppContext } from '../../../context/AppSettingsContextProvider'
import { GridLayout, GridLayouts } from '../../../interfaces/IGridSettings'
import { EventDto } from '../../../interfaces/IEvent'
import { EventType } from '../../../interfaces/IEventEnums'

interface GridSettingsProps {
  viewEvent: EventDto
  onChange: (gridLayout: GridLayout) => void
}

export default function GridSettings({ viewEvent, onChange }: GridSettingsProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const { eventGridLayout, setEventGridLayout } = useAppContext()
  const [gridLayout, setGridLayout] = useState<GridLayouts>(eventGridLayout)

  const typeEventGridLayout = () => {
    if (viewEvent?.type === EventType.Generell) {
      return eventGridLayout.Generell
    }

    if (viewEvent?.type === EventType.Fellesfeil) {
      return eventGridLayout.Fellesfeil
    }

    return eventGridLayout.Planlagt
  }

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const handleGridLayoutChange = (gridLayoutChange: GridLayout) => {
    setEventGridLayout({
      ...gridLayout,
      [viewEvent?.type as EventType]: gridLayoutChange,
    })
    setGridLayout({
      ...gridLayout,
      [viewEvent?.type as EventType]: gridLayoutChange,
    })
    onChange(gridLayoutChange)
  }

  useEffect(() => {
    setEventGridLayout({
      ...gridLayout,
    })
    onChange(typeEventGridLayout())
  }, [gridLayout])

  return (
    <>
      <Fab
        color={'info'}
        sx={{
          position: 'fixed',
          bottom: 20,
          left: 20,
        }}
        size="medium"
        onClick={handleClick}
      >
        <GridViewOutlinedIcon />
      </Fab>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        slotProps={{
          paper: {
            style: {
              backgroundColor: 'transparent',
              boxShadow: 'none',
              overflow: 'hidden',
              position: 'absolute',
              left: 0,
              bottom: 0,
            },
          }
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Box
            sx={{
              p: 4,
              width: 400,
              borderRadius: 1,
              bgcolor: 'background.paper'
            }}>
            <GridLayoutSelection viewEvent={viewEvent} gridLayout={typeEventGridLayout()} onChange={handleGridLayoutChange} />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
